// The app shell's layout classes, in their own module so the regression guard
// (src/dom-tests/appShellViewportHeight.test.tsx) can render the real value
// instead of a copy of it — a copy keeps passing after the shell changes.
//
// The shell is viewport-locked: exactly one height authority (`h-dvh`), nothing
// scrolls at the document level, and every route owns an inner scroller (see
// `components/utils/RouteScroller.tsx`). See App.tsx for why `min-h-0` has to
// be here.
//
// `overflow-clip`, not `overflow-hidden`: a hidden box is still a scroll
// container, so a `scrollIntoView` or a focus landing on something that has
// overflowed it scrolls the shell with no scrollbar to bring it back (the
// "frozen chrome" failure). A clipped box cannot be scrolled by anything.
export const APP_SHELL_CLASSNAME =
  "w-dvw h-dvh min-h-0 flex flex-col overflow-clip [--header-height:calc(--spacing(14))]";
